import { Params } from './query'

type Mix<T> = T[] | Response<T>

export type Response<T> = { rows: T[]; total: number }

export type Invoker<T> =
  | Mix<T>
  | ((params?: Params) => Mix<T>)
  | ((params?: Params) => Promise<Mix<T>>)

export const empty = { rows: [], total: 0 }

export async function invoke<T>(invoker: Invoker<T>, params?: Params) {
  return typeof invoker === 'function'
    ? warp(await invoker(params))
    : warp(invoker)
}

function warp<T>(mix: Mix<T>) {
  return Array.isArray(mix) ? { rows: mix, total: mix.length } : mix
}
